import { template as template_4a05fcb4f9bd484d97ad4115c07fcf04 } from "@ember/template-compiler";
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default template_4a05fcb4f9bd484d97ad4115c07fcf04(`
  <span class="tooltip-wrapper" aria-label={{t "shared.accessibility.helpLabel"}}>
    {{svgJar "help" class="icon" aria-hidden="true"}}
    <AttachTooltip @class="tooltip align-left">
      {{yield}}
    </AttachTooltip>
  </span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
